import { createFileRoute, Link } from '@tanstack/react-router';

import { NotificationsTabs } from '../../features/notifications/notifications-tabs';
import { RemindersScreen } from '../../features/notifications/reminders-screen';
import { NOTIFICATION_PERMISSIONS } from '../../features/notifications/types';
import { RequirePermission } from '../../lib/session/guards';

export const Route = createFileRoute('/notifications/reminders')({
  component: RemindersPage,
});

/**
 * `/notifications/reminders` — what the queue will send next (MASTER_PLAN M9.8,
 * FR-NOTIF-04). Read-only: a reminder is re-planned by changing the appointment.
 */
function RemindersPage() {
  return (
    <RequirePermission keys={[NOTIFICATION_PERMISSIONS.read]}>
      <RemindersScreen
        renderTabs={() => (
          <NotificationsTabs
            active="reminders"
            renderLink={(to, children, props) => (
              <Link to={to} className={props.className} aria-current={props['aria-current']}>
                {children}
              </Link>
            )}
          />
        )}
      />
    </RequirePermission>
  );
}
